import { makeAutoObservable } from 'mobx'
import { RootStore } from './Root.store'

interface UserAgent {
  engine?: string
  browser?: string
  system?: string
  isMobile?: boolean
}

export class AppStateStore {
  private rootStore: RootStore
  shouldRunHandleVisibilityChange = true
  userAgent: UserAgent = {}
  shouldAskForPhoneNumber: boolean = false
  shouldAskForEmail: boolean = false
  shouldSelectDocument: boolean = true
  askUserForPlaceAndCountryOfBirth: boolean = false
  showVideoIdHintsScreen: boolean = false
  iframeContent: boolean = false
  showTransactionCompletedWaitingScreen: boolean = false
  documentUploadUrl: string = ''

  screenSize = {
    width: 0,
    height: 0,
  }
  isMobile: boolean = false
  initialScreenSize = {
    width: 0,
    height: 0,
  }
  deprecatedPageWidth: number = 0
  deprecatedPageHeight: number = 0
  deprecatedScreenSize = {
    width: 0,
    height: 0,
  }

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)

    this.rootStore = rootStore
  }

  setShouldAskForPhoneNumber(required: boolean): void {
    this.shouldAskForPhoneNumber = required
  }

  setShouldAskForEmail(required: boolean): void {
    this.shouldAskForEmail = required
  }

  setShouldSelectDocument(required: boolean): void {
    this.shouldSelectDocument = required
  }

  setAskUserForPlaceAndCountryOfBirth(required: boolean): void {
    this.askUserForPlaceAndCountryOfBirth = required
  }

  setShowVideoIdHintsScreen(required: boolean): void {
    this.showVideoIdHintsScreen = required
  }

  setUserAgent(userAgent: UserAgent): void {
    this.userAgent = userAgent
  }

  setScreenSize(screenSize: { width: number; height: number }): void {
    this.screenSize = screenSize

    if (screenSize.width <= 980) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  }

  setInitialScreenSize(screenSize: { width: number; height: number }): void {
    if (this.initialScreenSize.width === 0 && this.initialScreenSize.height === 0) {
      this.initialScreenSize = {
        width: screenSize.width,
        height: screenSize.height > 450 ? screenSize.height : 450, // Ensure minimum height
      }
    }
  }

  setDeprecatedScreenSize(screenSize: { width: number; height: number }): void {
    this.deprecatedScreenSize = screenSize
  }

  setIframeContent(enabled: boolean): void {
    this.iframeContent = enabled
  }

  setShowTransactionCompletedWaitingScreen(show: boolean): void {
    this.showTransactionCompletedWaitingScreen = show
  }

  setDocumentUploadUrl(url: string): void {
    this.documentUploadUrl = url
  }

  setShouldRunHandleVisibilityChange(shouldRun: boolean) {
    this.shouldRunHandleVisibilityChange = shouldRun
  }
}
